import { useEffect } from 'react'

import { stopLoading } from 'src/actions/loadingActions'

import { useDispatch } from 'react-redux'
import Scrollbar from 'react-smooth-scrollbar'

import { ConfigurableDashboard } from '../../components/Dashboard/components/ConfigurableDashboard'
import { DashboardProvider } from '../../components/Dashboard/context/DashboardContext/provider'

const Dashboard = (): JSX.Element => {
  const dispatch = useDispatch()
  useEffect(() => void dispatch(stopLoading()), [dispatch])

  return (
    <Scrollbar>
      <DashboardProvider>
        <ConfigurableDashboard />
      </DashboardProvider>
    </Scrollbar>
  )
}

export default Dashboard
